import React, {useContext, useEffect, useState} from 'react';
import styles from './InviteFriends.module.css';


import {SwapMainAppContext} from '../../context/SwapMainAppContext';
import {PRISMAX_BACKEND_URL, APP_URL} from '../../configs/config';

import copy_icon from '../../static_files/invite copy.svg';

import robot_icon from '../../static_files/robot.svg';
import points_icon from '../../static_files/point icon.svg';

import x_icon from '../../static_files/invite x.svg';
import tele_icon from '../../static_files/invite telegram.svg'
import whatsapp_icon from '../../static_files/invite whatsapp.svg';
import qr_icon from "../../static_files/invite qr.svg"

import QRCodeModal from "./QRCodeModal";

function InviteFriends() {
    const {
        showNotification,
        walletAddress,
        userEmail,
        selectedChain,
        referralCode,
        userId,
        gatewayToken,
    } = useContext(SwapMainAppContext);
    const [totalReferrals, setTotalReferrals] = useState('--');
    const [totalEarnings, setTotalEarnings] = useState(0);

    const [isWalletLoading, setIsWalletLoading] = useState(true);
    const [showQrCodeModal, setShowQrCodeModal] = useState(false);


    useEffect(() => {
        if (walletAddress || userEmail) {
            setIsWalletLoading(true);
        }
        if (!walletAddress && !userEmail) {
            setIsWalletLoading(false);
        }
    }, [walletAddress, userEmail, referralCode]);


    useEffect(() => {
        const fetchReferralsData = async () => {
            try {
                const params = new URLSearchParams();
                params.append('referrers_referral_code', referralCode);
                params.append('userid', userId);

                const res = await fetch(
                    `${PRISMAX_BACKEND_URL}/api/get-users-by-referral?${params.toString()}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${gatewayToken}`,
                        },
                    }
                );
                if (!res.ok) {
                    const errText = await res.text().catch(() => res.statusText);
                    throw new Error(`Error fetching data: ${errText || res.statusText}`);
                }
                const data = await res.json();
                if (data.success) {
                    setTotalReferrals(data.count || 0);
                    setTotalEarnings(Number(data.referred_reward_point || 0));

                } else {
                    setTotalReferrals(0);
                    setTotalEarnings(0);
                }
                setIsWalletLoading(false);

            } catch (error) {
                console.error(error);
                showNotification("error", `Error fetching referrals data: ${error}`);
                setIsWalletLoading(false);
            }
        };

        if (referralCode && userId && gatewayToken) {
            fetchReferralsData();
        } else if (!walletAddress && !userEmail) {
            setIsWalletLoading(false);
        } else if (!userId || !gatewayToken) {
            // Avoid indefinite loading if auth context isn't ready
            setIsWalletLoading(false);
            setTotalEarnings(0);
        }
    }, [referralCode, showNotification, walletAddress, userEmail, userId, gatewayToken]);


    const handleCopy = (e) => {
        e.stopPropagation();

        if (!referralCode) return;

        navigator.clipboard
            .writeText(`https://app.prismax.ai/invite-friend/${referralCode}`)
            .then(() => {
                showNotification("success", "Link successfully copied to clipboard");
            })
            .catch((err) => {
                showNotification("error", `Failed to copy link: ${err}`);
            });
    };

    function handleShare(platform) {
        const textShare = "Invite friends to join the robotic revolution and earn together.";
        const referralUrl = `https://app.prismax.ai/invite-friend/${referralCode}`;

        switch (platform) {
            case 'x': {
                const textShare = "Invite friends to join the robotic revolution and earn together.";
                const referralUrl = `https://app.prismax.ai/invite-friend/${referralCode}`;

                const intent = new URL('https://twitter.com/intent/tweet');
                intent.searchParams.set('text', textShare.replace(/\s*\n+\s*/g, ' ')); // strip any accidental newlines
                intent.searchParams.set('url', referralUrl);

                window.open(intent.toString(), '_blank', 'noopener,noreferrer');
                break;
            }


            case 'telegram':
                window.open(
                    `https://t.me/share/url?url=${encodeURIComponent(referralUrl)}&text=${encodeURIComponent(
                        textShare
                    )}`,
                    '_blank'
                );
                break;

            case 'whatsapp':
                window.open(
                    `https://api.whatsapp.com/send?text=${encodeURIComponent(
                        `${textShare}\n${referralUrl}`
                    )}`,
                    '_blank'
                );
                break;

            case 'qr':
                setShowQrCodeModal(true)
                break;

            default:
                break;
        }
    }

    return (
        <div className={styles.mainContainer}>


            <div className={styles.inviteSection}>
                <p className={styles.title}>
                    Invite friends to join the robotic<br/> revolution and earn together
                </p>
                <p className={styles.inviteDescription}>
                    Get 500 Prisma Points per Explorer referral, plus 10% ongoing bonus from<br/> each friend's
                    future point earnings.
                </p>

                <div className={styles.socialIcons}>
                    <div className={styles.iconContainer} onClick={() => handleShare('x')}>
                        <img className={styles.socialIcon} src={x_icon} alt="x"/>
                        X
                    </div>

                    <div className={styles.iconContainer} onClick={() => handleShare('telegram')}>
                        <img className={styles.socialIcon} src={tele_icon} alt="telegram"/>
                        Telegram
                    </div>

                    <div className={styles.iconContainer} onClick={() => handleShare('whatsapp')}>
                        <img className={styles.socialIcon} src={whatsapp_icon} alt="whatsApp"/>
                        WhatsApp
                    </div>

                    <div className={styles.iconContainer} onClick={() => handleShare('qr')}>
                        <img className={styles.socialIcon} src={qr_icon} alt="qr_code"/>
                        QR Code
                    </div>
                </div>

                <div className={styles.inviteLinkRow}>
                    {referralCode ? <input
                        type="text"
                        readOnly
                        value={`app.prismax.ai/invite-friend/${referralCode}`}
                        className={styles.inviteLinkInput}
                    /> : <input
                        type="text"
                        readOnly
                        value={``}
                        className={styles.inviteLinkInput}
                    />}
                    <button onClick={handleCopy} className={styles.copyButton}>
                        <img className={styles.copyBtn}
                             src={copy_icon}
                             alt="copy"></img>
                        Copy Link
                    </button>
                </div>
                <div className={styles.myReferralsOuterContainer}>


                    <div className={styles.referralsRow}>
                        {/* Box #1 */}
                        <div className={styles.referralBox}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                width: '100%',
                                alignItems: 'center'
                            }}><p
                                className={styles.boxLabel}>Total Referrals</p>
                            </div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                width: '100%'
                            }}>
                                <p className={styles.boxValue}>{totalReferrals}</p>
                                <div className={styles.boxIconWrapper}><img className={styles.boxIcon} src={robot_icon}
                                                                            alt=''/></div>
                            </div>
                        </div>


                        {/* Box #2 */}
                        <div className={styles.referralBox}>
                            <div style={{display: 'flex', justifyContent: 'flex-start', width: '100%'}}><p
                                className={styles.boxLabel}>Total earnings</p></div>
                            <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
                                <p className={styles.boxValue}>{totalEarnings.toLocaleString('en-US')}</p>
                                <div className={styles.boxIconWrapper}><img className={styles.boxIcon} src={points_icon}
                                                                            alt=''/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <QRCodeModal
                isOpen={showQrCodeModal}
                onClose={() => setShowQrCodeModal(false)}
                referralUrl={`https://app.prismax.ai/invite-friend/${referralCode}`}
                referralCode={referralCode}
            />
        </div>
    );
}

export default InviteFriends;
